interface DataType {
   id: number;
   page: string;
   icon: string;
   country: string;
   course: number;
};

const categories_data: DataType[] = [
   {
      id: 1,
      page: "home_6",
      icon: "/assets/img/flags/flag_01.svg",
      country: "German",
      course: 2,
   },
   {
      id: 2,
      page: "home_6",
      icon: "/assets/img/flags/flag_02.svg",
      country: "Canada",
      course: 4,
   },
   {
      id: 3,
      page: "home_6",
      icon: "/assets/img/flags/flag_03.svg",
      country: "France",
      course: 7,
   },
   {
      id: 4,
      page: "home_6",
      icon: "/assets/img/flags/flag_04.svg",
      country: "Italy",
      course: 3,
   },
   {
      id: 5,
      page: "home_6",
      icon: "/assets/img/flags/flag_05.svg",
      country: "Japan",
      course: 5,
   },
   {
      id: 6,
      page: "home_6",
      icon: "/assets/img/flags/flag_06.svg",
      country: "Denmark",
      course: 8,
   },
   {
      id: 7,
      page: "home_6",
      icon: "/assets/img/flags/flag_07.svg",
      country: "Ghana",
      course: 2,
   },
   {
      id: 8,
      page: "home_6",
      icon: "/assets/img/flags/flag_08.svg",
      country: "New Zealand",
      course: 6,
   },

   // home_8

   {
      id: 1,
      page: "home_8",
      icon: "/assets/img/categories/cat_img01.jpg",
      country: "Chinese",
      course: 22,
   },
   {
      id: 2,
      page: "home_8",
      icon: "/assets/img/categories/cat_img02.jpg",
      country: "Dessert",
      course: 15,
   },
   {
      id: 3,
      page: "home_8",
      icon: "/assets/img/categories/cat_img03.jpg",
      country: "Italian",
      course: 30,
   },
   {
      id: 4,
      page: "home_8",
      icon: "/assets/img/categories/cat_img04.jpg",
      country: "Bread",
      course: 20,
   },
   {
      id: 5,
      page: "home_8",
      icon: "/assets/img/categories/cat_img05.jpg",
      country: "Pizza",
      course: 50,
   },
   {
      id: 6,
      page: "home_8",
      icon: "/assets/img/categories/cat_img06.jpg",
      country: "Salad",
      course: 10,
   },
   {
      id: 7,
      page: "home_8",
      icon: "/assets/img/categories/cat_img07.jpg",
      country: "Italian",
      course: 12,
   },
   {
      id: 8,
      page: "home_8",
      icon: "/assets/img/categories/cat_img08.jpg",
      country: "Chinese",
      course: 25,
   },
];

export default categories_data;